var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.chartOption,"autoresize":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }